import ListData from "./ListData";
import TableData from "./TableData";

const passwordHealthComponents = {
  ListData,
  TableData
}

export default passwordHealthComponents